import * as React from 'react';
import SimpleSelect from './SimpleSelect';
var MONTHS = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
];
function MonthPicker(props) {
    var error = props.error, value = props.value, onChange = props.onChange;
    return (React.createElement(SimpleSelect, { includeBlank: true, error: error, value: value, items: MONTHS, onChange: onChange }));
}
export default MonthPicker;
